import React, { useState, useRef } from "react";
import { Form, Col, Row, Button, Table, Container } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";
import CustomTooltip from "utils/CustomTooltip";
import DatePicker from "react-datepicker";

export default function GoogleAnalyticsIds(props) {
  const [googleAnalyticsIds, setGoogleAnalyticsIds] = useState(jsDig(["google_analytics", "account_ids"], props.platformData) ? jsDig(["google_analytics", "account_ids"], props.platformData) : []);
  const [googleAnalyticsEnabled, setGoogleAnalyticsEnabled] = useState(jsDig(["google_analytics", "enabled"], props.platformData) ? jsDig(["google_analytics", "enabled"], props.platformData) : false);
  const [ga4Date, setGa4Date] = useState(props.ga4Date)

  const handleIdDelete = (targetIndex) => {
    let newIds = googleAnalyticsIds.filter((id, index) => {
      return targetIndex != index;
    });
    setGoogleAnalyticsIds(newIds);
  };

  const handleIdChange = (targetIndex, property, value) => {
    let newIds = googleAnalyticsIds.map((id, index) => {
      let newId = id;
      if (index == targetIndex) {
        newId[property] = value;
      }
      return newId;
    });
    setGoogleAnalyticsIds(newIds);
  };

  let firstImg = require("images/analytics-screenshot-1.png");
  let secondImg = require("images/analytics-screenshot-2.png");
  firstImg = <img style={{ maxWidth: '400px' }} src={`/datapulse${firstImg}`} />;
  secondImg = <img style={{ maxWidth: '400px' }} src={`/datapulse${secondImg}`} />;
  const idTooltipMessage = () => {
    return (
      <>
        <div>
          There are 2 types of Google Analytics properties, GA4 and UA.
          <br></br>
          <br></br>
          For UA, the ID to use in DataPulse is the view ID. That can be extracted from the URL after you select the relevant view:
          {firstImg}
          <br></br>
          The view ID is the number that comes after the 'p' in the URL.
          <br></br>
          <br></br>
          For GA4, the ID to use is the profile ID. That can also be extracted from the URL after you select the relevant property:
          {secondImg}
          <br></br>
          The property ID is the number that comes after the 'p' in the URL.
        </div>
      </>
    )
  }

  const calendarForm = (name, defaultDate) => {
    const [startDate, setStartDate] = useState(new Date(props.ga4Date));

    const handleStartDateChange = (date) => {
      setStartDate(date);
    }

    const formatDate = (date) => {
      return moment(date).format("YYYY,MM,DD");
    };

    const calendarRef = useRef();

    return (
      <>
        <div className="d-flex data-pull">
          <div className="dateSelectorPull">
            <i
              style={{ paddingRight: "8px" }}
              onClick={() => {
                calendarRef.current.setOpen(true);
              }}
              className="far f20 fa-calendar-alt"></i>
            <DatePicker
              ref={calendarRef}
              autoComplete="off"
              dateFormat="MM/dd/yy"
              selected={startDate}
              onChange={handleStartDateChange}
              popperProps={{
                positionFixed: true,
              }}
            />
          </div>
          <input hidden readOnly name={`ga4_date`} value={formatDate(startDate)} />
        </div>
      </>
    );
  };

  let segmentImg = require("images/analytics-segment.png");
  segmentImg = <img  src={`/datapulse${segmentImg}`} />;
  const tooltipMessage = () => {
    return (
      <>
        <div>
          In Analytics, apply the segment you wish to use and check the URL for the parameter '_.useg'. The segment ID is everything that follows the 'user' string.  For pulling a built-in segment, take the number after 'builtin' and add a hyphen '-' before.
          {segmentImg}
          <br></br>
          <br></br>
          Also please note that the segment must be shared in order to work. To do this, when creating or editing a segment, in the top right you'll see "Segment is visible in any View. Change" click Change then select "Collaborators and I can apply/edit Segment in this view". Click okay, then save the segment.
          <br></br>
          Click this tooltip for a guided walkthrough.
        </div>
      </>
    )
  }

  return (
    <>
      <Row className="pb-3 align-items-center">
        <Col xs={"auto"} className="pr-0 pl-0">
          <CustomFormCheck sendUncheckedValue id="google_analytics_enabled" name="google_analytics_enabled" checked={googleAnalyticsEnabled} label="Enable Google Analytics" onChange={() => setGoogleAnalyticsEnabled(!googleAnalyticsEnabled)} />
        </Col>
      </Row>
      <Row className="py-4 align-items-center">
        <Col xs={"auto"} className="pr-0 pl-0">
          <span>GA4 Date:</span>
        </Col>
        <Col xs={"auto"}>
        {calendarForm()}
        </Col>
        <Col className="pl-0" xs={"auto"}>
        </Col>
      </Row>

      <Row className="py-3 px-0" style={{ backgroundColor: "#F5F5F5" }}>
        <Col>
          <div className="table-responsive pb-3">
            <Table className="ga-table overflow-hidden">
              <thead>
                <tr>
                  <td className="pl-3 f12 light-primary">Label</td>
                  <td
                    className="pl-3 f12 light-primary">
                    <span>ID</span>
                    <span>
                      <CustomTooltip
                        faClass="far  fa-question-circle f16 pl-2"
                        message= {idTooltipMessage()}
                        inline={true}
                      />
                    </span>
                  </td>
                  <td
                    className="pl-3 f12 light-primary"
                    style={{
                      whiteSpace: "nowrap",
                      float: "left",
                      width: "30px",
                    }}>
                    <span>Add custom segment ID</span>
                    <span>
                      <a href="https://www.dropbox.com/sh/iwiogm8s4ckhucz/AACAIZ94nwzQnSp8bSNYQxaya?dl=0&preview=Implementing+Segments+in+DataPulse.mkv" target="_blank">
                        <CustomTooltip
                          faClass="far  fa-question-circle f16 pl-2"
                          message= {tooltipMessage()}
                          inline={true}
                        />
                      </a>
                    </span>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {googleAnalyticsIds.map((googleAnalyticsId, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <Form.Control readOnly={!googleAnalyticsEnabled} size="sm" placeholder="Label" name={`[google_analytics_ids][][label]`} value={jsDig(["label"], googleAnalyticsId) ? jsDig(["label"], googleAnalyticsId) : ""} onChange={(e) => handleIdChange(index, "label", e.target.value)} />
                      </td>
                      <td>
                        <Form.Control readOnly={!googleAnalyticsEnabled} size="sm" placeholder="ID" name={`[google_analytics_ids][][id]`} value={jsDig(["id"], googleAnalyticsId) ? jsDig(["id"], googleAnalyticsId) : ""} onChange={(e) => handleIdChange(index, "id", e.target.value)} />
                      </td>
                      <td className="pl-3">
                        <CustomFormCheck
                          sendUncheckedValue
                          disabled={!googleAnalyticsEnabled}
                          name={`[google_analytics_ids][][custom_segment_enabled]`}
                          id={`google-analytics-id-${index}-custom-segment-enabled`}
                          checked={jsDig(["custom_segment_enabled"], googleAnalyticsId) == "1" ? true : false}
                          onChange={(e) => handleIdChange(index, "custom_segment_enabled", e.target.checked ? "1" : "0")}
                        />
                      </td>
                      <td className="pl-0">
                        <Form.Control
                          readOnly={!googleAnalyticsEnabled}
                          size="sm"
                          placeholder="Custom segment ID"
                          name={`[google_analytics_ids][][custom_segment]`}
                          value={jsDig(["custom_segment"], googleAnalyticsId) ? jsDig(["custom_segment"], googleAnalyticsId) : ""}
                          onChange={(e) => handleIdChange(index, "custom_segment", e.target.value)}
                        />
                      </td>
                      {/* <CustomRowSegment id={uuidv4()}/> */}
                      <td>
                        {(index >= 0 && googleAnalyticsIds.length > 1) && (
                          <i
                            className=" pl-2 fas fa-minus-circle"
                            onClick={(e) => {
                              handleIdDelete(index);
                            }}></i>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div className="text-center text-md-left">
            <Button
              className="mt-3 mb-3 ml-2 mr-4 px-4 py-1"
              size="sm"
              as="input"
              type="button"
              onClick={(e) => {
                setGoogleAnalyticsIds((prevState) => [...prevState, {}]);
              }}
              value="+ Add Google analytics ID"
              variant="success"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
